export const FR = "fr"
export const AR = "ar"
export const EN = "en"
